import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app/'

const client = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Interceptor para agregar token de autenticación
client.interceptors.request.use(config => {
  const token = localStorage.getItem('user-token')
  if (token) {
    config.headers.Authorization = `Token ${token}`
  }
  return config
})

export const caddiesService = {
  // Listar todos los caddies
  async getCaddies (params = {}) {
    const response = await client.get('/caddies/', { params })
    return response.data
  },

  // Obtener detalles completos de un caddie
  async getCaddieDetail (id) {
    const response = await client.get(`/caddies/${id}/extended-info/`)
    return response.data
  },

  // Crear nuevo caddie
  async createCaddie (data) {
    const response = await client.post('/caddies/', data)
    return response.data
  },

  // Actualizar caddie
  async updateCaddie (id, data) {
    const response = await client.patch(`/caddies/${id}/`, data)
    return response.data
  },

  // Eliminar caddie
  async deleteCaddie (id) {
    await client.delete(`/caddies/${id}/`)
  },

  // Búsqueda avanzada
  async searchCaddies (params = {}) {
    const response = await client.get('/caddies/search/', { params })
    return response.data
  },

  // Desactivar caddie
  async deactivateCaddie (id) {
    const response = await client.post(`/caddies/${id}/deactivate/`, {})
    return response.data
  },

  // Activar caddie
  async activateCaddie (id) {
    const response = await client.post(`/caddies/${id}/activate/`, {})
    return response.data
  },

  // Obtener calificaciones de un caddie
  async getCaddieRatings (id, params = {}) {
    const response = await client.get(`/caddies/${id}/ratings/`, { params })
    return response.data
  },

  // Obtener estadísticas agregadas
  async getStats (params = {}) {
    const response = await client.get('/caddies/stats/', { params })
    return response.data
  },

  // Verificar disponibilidad de caddies
  async checkAvailability (params = {}) {
    const response = await client.get('/caddies/availability/', { params })
    return response.data
  }
}
